import React from 'react'
import { Link } from "gatsby"
import { Button, Alert } from "react-bootstrap"
import Icon from "../../assets/ArrowWithStem.svg"

// ** Reason for utility: **
// Link uri data from drupal comes littered
// entity: = node/XXX - typically this cannot be used so we alert the editor
// internal: = path alias - this can be used once the internal: part is removed
// external: = path

// Navigate to Section based on hash
const navigateToSection = (e, sectionId) => {
  e.preventDefault()
  sectionId = sectionId.substring(1)
  
  const element = document.getElementById(sectionId)

  if(element !== null) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }
}


// data expects an object
// .title
// .uri
// style: defaults to just a link
const drupalLink = (data, style, variant="primary", target="", hasIcon=true) => {
  let linkTo = data.uri
  let nodeWarning = false
  
  let icon = hasIcon && <Icon width="24" /> || <></>;

  if(data.url) {
    // preferred use
    linkTo = data.url
  }
  else {
    // use URI - not as clean
    if(linkTo.indexOf('entity:') > -1){
      linkTo = linkTo.replace('entity:', '/')
    }
    else if(linkTo.indexOf('internal:') > -1) {
      linkTo = linkTo.replace('internal:', '')
    }
    else if(linkTo.indexOf('external:') > -1) {
      linkTo = linkTo.replace('external:', '')
    }
  }

  // Formatting linkTo style if linkTo is hash URL
  if (linkTo.charAt(0) === "#" && style === 'Button') {
    style = 'hashlinkButton'
  } else if (linkTo.charAt(0) === "#" && style !== 'Button') {
    style = 'hashlink'
  }

  // if an incompatable node/xxx link is provided we warn the editor
  // - this could be alternativly hidden
  if(linkTo.indexOf('/node/') > -1) {
    nodeWarning = true
  }

  // If an internal link (or absolute link to JMF site) make sure that we have a trailing slash
  let addTrailingSlash = true

  if(linkTo.at(-1) === '/') {
    addTrailingSlash = false
  }
  else if(linkTo.indexOf('.pdf') > 0) { // pdf file
    addTrailingSlash = false
  }
  else if(linkTo.indexOf('mailto:') > 0) { // email
    addTrailingSlash = false
  }
  else if(linkTo.indexOf('tel:') > 0) { // tel
    addTrailingSlash = false
  }
  else if(linkTo.indexOf('http:') > 0 && linkTo.indexOf('jmfinn.') < 0) { // external site link
    addTrailingSlash = false
  }
  else if(linkTo.indexOf('?') > -1) { // query string
    addTrailingSlash = false
  }
  else if(linkTo.indexOf('#') > -1) { // anchor string
    addTrailingSlash = false
  }

  if(addTrailingSlash) {
    linkTo = linkTo + '/'
  }

  if(typeof data === 'object') {
    let formattedLink = ""

    if(style === "Button") {
      formattedLink = (
        <Link to={linkTo} target={target}>
          <Button variant={variant}>{data.title} {icon}</Button>
        </Link>
      )
    } else if(style === 'hashlinkButton') {
      formattedLink = (
        <a href={linkTo} target={target} onClick={(e) => navigateToSection(e, linkTo)}>
          <Button variant={variant}>{data.title} {icon}</Button>
        </a>
      )
    } else if(style === 'hashlink') {
      formattedLink = (
        <a href={linkTo} target={target} onClick={(e) => navigateToSection(e, linkTo)}>{data.title} {icon}</a>
      )
    }
    else {
      formattedLink = (
        <Link to={linkTo} target={target}>{data.title} {icon}</Link>
      )
    }

    if(nodeWarning === true){
      //console.log("Warning: Node link found for '"+data.title+"'. Please convert this to a relative path using the CMS.");
      formattedLink = (
        <Alert variant="danger">
          {formattedLink}
        </Alert>
      )
    }

    return(formattedLink)
  }
  else {
    return ('')
  }

}

export { drupalLink }

